import { Archive, Bell, Copy, Download, Link2, Trash2, Upload } from "lucide-react";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/modern/components/ui/dropdown-menu";

type Props = {
  archived?: boolean;
  canEdit: boolean;
  onArchive: () => void;
  onCopyLink: () => void;
  onDuplicate: () => void;
  onImport: () => void;
  onExport: () => void;
  onNudge: () => void;
  onDelete: () => void;
};

/** Shared checklist overflow actions (entity editor + board Checklists surface). */
export function ChecklistMenuItems({
  archived,
  canEdit,
  onArchive,
  onCopyLink,
  onDuplicate,
  onImport,
  onExport,
  onNudge,
  onDelete
}: Props) {
  return (
    <>
      <DropdownMenuItem onClick={onArchive} disabled={!canEdit}>
        <Archive className="size-4" />
        {archived ? "Unarchive" : "Archive"}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onCopyLink}>
        <Link2 className="size-4" />
        Copy Link
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onDuplicate} disabled={!canEdit}>
        <Copy className="size-4" />
        Duplicate
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onImport} disabled={!canEdit}>
        <Download className="size-4" />
        Import Checklist Items
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onExport} disabled={!canEdit}>
        <Upload className="size-4" />
        Export Checklist Items
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onNudge} disabled={!canEdit}>
        <Bell className="size-4" />
        Nudge Users
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={onDelete}
        disabled={!canEdit}
        className="text-red-600 focus:bg-red-50 focus:text-red-700 dark:text-red-400 dark:focus:bg-red-950/30 dark:focus:text-red-300"
      >
        <Trash2 className="size-4" />
        Delete Checklist
      </DropdownMenuItem>
    </>
  );
}
